module.exports = __webpack_public_path__ + "img/teacher-authorize-discheck.a8b13b4c.svg";